import React from "react";
import Button from "./Button";

const ButtonGroup = ({
  buttons,
  onButtonClick,
  selected,
  boxClass = "col-span-2",
}) => {
  return (
    <>
      {buttons?.map((button, index) => (
        <div key={index} className={`${boxClass}`}>
          <Button
            className={`${
              selected === button.value
                ? "bg-primary-600 text-white"
                : "border bg-primary-50 border-primary-600"
            } h-[36px] text-secondry-600 py-2 px-2 lg:px-5 w-full text-[13px] text-start leading-[20px] rounded-[8px] font-medium shadow-none outline-none flex items-center justify-between`}
            onClick={() => onButtonClick(button.value)}
          >
            {button.label}
            {button?.count && <span>{button.count}</span>}
          </Button>
        </div>
      ))}
    </>
  );
};

export default ButtonGroup;
